import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    selectHMI: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        marginTop: "8px",
    },
    selectHMITitle: {
        color: theme.palette.info.main,
        fontSize: "16px",
        fontWeight: 600,
        fontFamily: "Open Sans",
        marginBottom: "20px",
    },
    selectHMIContent: {
        display: "flex",
        gap: "20px",
        flexDirection: "column",
    },
    boxContainer: {
        width: "100%",
    },
    formLabel: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root.Mui-focused": {
            color: theme.palette.primary.dark,
        },
    },
    select: {
        "& .MuiInputBase-input": {
            fontFamily: "Open Sans",
            fontSize: "14px",
            fontWeight: "400",
            padding: "9px 12px !important",
            color: `${theme.palette.text.secondary} !important`,
        },
        "& .Mui-disabled": {
            "& .MuiChip-root": {
                backgroundColor: `${theme.palette.border.select} !important`,
                color: `${theme.palette.text.secondary} !important`,
            },
        },
    },
    menuItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between !important",
        gap: 4,
        fontSize: `14px !important`,
        "&.Mui-selected": {
            backgroundColor: `${theme.palette.secondary.main} !important`,
        },
    },
    box: {
        display: "flex !important",
        flexWrap: "wrap",
        gap: 0.5,
    },
}));
